import React from 'react';
import { Link } from 'react-router-dom';
import './Fluids.css'; // Import custom CSS for styling

// Import all images
import image1 from '../images/image1.jpg';
import image2 from '../images/image2.jpg';
import image3 from '../images/image3.jpg';
import image4 from '../images/images4.jpg';
import image5 from '../images/images5.jpg';
import image6 from '../images/images6.jpg';
import image7 from '../images/image7.jpg';
import image8 from '../images/image8.jpg';
import image9 from '../images/image9.jpg';

const Machine = () => {
  // Array of product objects
  const products = [
    {
      id: 1,
      name: 'Machine 1',
      description: 'High-quality fluid for printers.',
      image: image1,
      link: '/products/fluids/machine1'
    },
    {
      id: 2,
      name: 'Machine 2',
      description: 'Eco-friendly fluid.',
      image: image2,
      link: '/products/fluids/machine2'
    },
    {
      id: 3,
      name: 'Machine 3',
      description: 'Premium fluid with long-lasting performance.',
      image: image3,
      link: '/products/fluids/machine3'
    },
    {
      id: 4,
      name: 'Machine 4',
      description: 'Advanced fluid for specialized printers.',
      image: image4,
      link: '/products/fluids/machine4'
    },
    {
      id: 5,
      name: 'Machine 5',
      description: 'Cost-effective fluid for everyday use.',
      image: image5,
      link: '/products/fluids/machine5'
    },
    {
      id: 6,
      name: 'Machine 6',
      description: 'Eco-friendly and efficient fluid.',
      image: image6,
      link: '/products/fluids/machine6'
    },
    {
      id: 7,
      name: 'Machine 7',
      description: 'High-performance fluid for heavy-duty use.',
      image: image7,
      link: '/products/fluids/machine7'
    },
    {
      id: 8,
      name: 'Machine 8',
      description: 'Reliable fluid for consistent results.',
      image: image8,
      link: '/products/fluids/machine8'
    },
    {
      id: 9,
      name: 'Machine 9',
      description: 'Innovative fluid for cutting-edge printers.',
      image: image9,
      link: '/products/fluids/machine9'
    },
  ];

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 mb-4 text-center">
          <h3 className="main-heading">Machine</h3>
          <div className="underline mx-auto"></div>
        </div>
        {products.map((product) => (
          <div key={product.id} className="col-md-4 mb-4">
            <div className="card shadow-lg">
              <img src={product.image} alt={product.name} className="card-img-top" />
              <div className="card-body">
                <h5 className="card-title text-center">{product.name}</h5>
                <p className="card-text text-center">{product.description}</p>
                <Link to={product.link} className="btn btn-outline-primary d-block mx-auto">Read More</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Machine;
